module.exports = __webpack_public_path__ + "static/media/img-product.7052df96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-product.png
// module id = 666
// module chunks = 0